import React, { useEffect, useState } from "react";
import Container from "@/components/container/Container";
import CardWrapper from "@/components/card/CardWrapper";
import "@/styles/dashboard/transactions.scss";
import BackWithLabel from "@/components/common/BackWithLabel";
import { getRecentTransactions } from "@/services/payments/getRecentTransactions";
import { Card, Flex, Popover } from "antd";
import moment from "moment";
import IconBookSession from "@/components/icons/IconBookSession";
import IconPlanPurchase from "@/components/icons/IconPlanPurchase";
import IconDots from "@/components/icons/IconDots";
import IconReport from "@/components/icons/IconReport";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";
import { crateReport } from "@/services/users/getReportCategory";

const Transcations = () => {
  const [transactions, setTransactions] = useState([]);
  const dispatch = useDispatch();

  const onReportClick = (transactionId) => {
    dispatch(setCurrentForm("report"));
    dispatch(
      setFormProps({
        categoryType: "Transaction",
        handleSubmit: (data) => {
          if (data.categoryId && data.description) {
            data.metadata = { transactionId };
            crateReport(data).then((res) => {
              console.log(res);
              dispatch(setModalOpen(false));
              dispatch(setCurrentForm("successModal"));
              dispatch(setModalOpen(true));
              dispatch(
                setFormProps({
                  message: "Your report has been submitted successfully.",
                  btnLabel: "Close",
                  onSubmit: () => {
                    dispatch(setModalOpen(false));
                  },
                })
              );
            });
          }
        },
      })
    );
    dispatch(setModalOpen(true));
  };

  const content = ({ id }) => {
    return (
      <div className="menulink-popover">
        <Flex
          align="center"
          gap="0.5rem"
          className="color-brand cursor-pointer"
          onClick={() => {
            // dispatch(setModalOpen(true))
          }}
        >
          <IconReport />
          <span onClick={() => onReportClick(id)}>Report</span>
        </Flex>
      </div>
    );
  };
  useEffect(() => {
    getRecentTransactions().then((res) => setTransactions(res));
  }, []);

  console.log(transactions);
  return (
    <Container className="transactions-wrapper">
      <CardWrapper>
        <BackWithLabel label="Recent Transactions" path="/dashboard" />
        <Flex vertical gap={"10px"} style={{ padding: "1rem 0" }}>
          {transactions.map((x, i) => {
            return (
              <Card style={{ padding: "0.1rem" }} key={i}>
                <Flex justify="end" style={{ marginBottom: "10px" }}>
                  <Popover
                    placement="bottomRight"
                    content={content({
                      id: x.transactionId,
                    })}
                    // open={openId === index}
                    trigger="hover"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <IconDots className="cursor-pointer" on />
                  </Popover>
                </Flex>
                <Flex justify="space-between" className="price-chip">
                  <Flex align="center" gap="5px">
                    {x.transactionType === "booking" ? <IconBookSession /> : <IconPlanPurchase />}
                    {/* <img src="/assets/images/mastercard.png" /> */}
                    <span className="title-h6">{x?.referenceName}</span>
                  </Flex>
                  {/* <span>{x.type?.toUpperCase()}</span> */}
                  <Flex>
                    <div
                      style={{
                        background: "#fde2e2",
                        color: "#e9635e",
                        padding: "0.2rem 0.5rem",
                        borderRadius: "5px",
                        marginRight: "20px",
                        fontWeight: 700,
                      }}
                    >
                      {x?.transactionType?.[0]?.toUpperCase() + x?.transactionType?.slice(1)}
                    </div>
                    <div
                      style={{
                        background: `${x?.settledAt === null ? "#fde2e2" : "#E0FFDF"}`,
                        color: `${x?.settledAt === null ? "#e9635e" : "#03A703"}`,
                        padding: "0.2rem 0.5rem",
                        borderRadius: "5px",
                        fontWeight: 700,
                      }}
                    >
                      {x?.settledAt === null ? "" : x?.currency === "USD" ? "$" : ""}
                      {x?.settledAt === null ? "Failed" : x?.amount}
                    </div>
                  </Flex>
                </Flex>
                <Flex vertical gap={"5px"}>
                  <Flex gap={"5px"} className="body-b5 o-8">
                    <span>Date:</span>
                    <span>{x.settledAt ? moment(x.settledAt).format("lll") : ""}</span>
                  </Flex>
                  <Flex gap={"5px"} className="body-b5 o-8">
                    <span>Tx Id:</span>
                    <span>{x?.transactionId}</span>
                  </Flex>
                </Flex>
              </Card>
            );
          })}
        </Flex>
      </CardWrapper>
    </Container>
  );
};

export default Transcations;
